import script from "./InnerNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./InnerNavbar.vue?vue&type=script&setup=true&lang=js"

import "./InnerNavbar.vue?vue&type=style&index=0&id=1540c045&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1540c045"]])

export default __exports__